// src/hooks/useTranslation.ts
import { useMemo } from 'react';
import enTranslations from '../translations/en.json';

type TranslationKey = string;
type InterpolationParams = Record<string, string | number>;

export const useTranslation = () => {
  const translations = useMemo(() => enTranslations, []);

  const t = (key: TranslationKey, params?: InterpolationParams): string => {
    const keys = key.split('.');
    let value: unknown = translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = (value as Record<string, unknown>)[k];
      } else {
        return key;
      }
    }

    if (typeof value !== 'string') {
      return key;
    }

    // Handle interpolation
    if (params) {
      return Object.entries(params).reduce((result, [paramKey, paramValue]) => {
        return result.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(paramValue));
      }, value);
    }

    return value;
  };

  return { t };
};